import { render } from "./vcurriculumlistedit.vue?vue&type=template&id=8eda5b66&scoped=true"
import script from "./vcurriculumlistedit.vue?vue&type=script&lang=js"
export * from "./vcurriculumlistedit.vue?vue&type=script&lang=js"

import "./vcurriculumlistedit.vue?vue&type=style&index=0&id=8eda5b66&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eda5b66"]])

export default __exports__